import { FC } from 'react';

import { HistoryMovement } from 'types';
import SharesTransferTableRow from './SharesTransferTableRow';
import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';

const SharesTransferTableBody: FC = () => {
  const { data } = useHistoryMovementsView();

  return (
    <tbody>
      {data.historyMovements?.map(
        (movement: HistoryMovement, index: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr className="tb-tnx-item" key={`movement-${index}`}>
            <SharesTransferTableRow movement={movement} index={index} />
          </tr>
        )
      )}
    </tbody>
  );
};

export default SharesTransferTableBody;
